/*
 * Authors: mariushirjanu
 * Created: 24/11/2023
 */
import { Override } from '../../../app-decorators';
import { TransporterBaseService } from './transporter-base.service';
import { Injectable } from '@angular/core';
import { ILogPayload, LogLevel } from '../remote-logger-data.service';

@Injectable()
export class ConsoleTransporterService implements TransporterBaseService {
  @Override(TransporterBaseService)
  public write(payload:ILogPayload, level:LogLevel):void {
    switch (level) {
      case LogLevel.INFO:
        return console.info(payload?.stack || payload?.message || payload);
      case LogLevel.DEBUG:
        return console.debug(payload?.stack || payload?.message || payload);
      case LogLevel.WARN:
        return console.warn(payload?.stack || payload?.message || payload);
      case LogLevel.ERROR:
        return console.error(payload?.stack || payload?.message || payload);
    }
  }
}